import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIndividualRegister = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 48,
			rx: 12,
			fill: "#EF4444"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31 32V31C31 28.7909 29.2091 27 27 27H21C18.7909 27 17 28.7909 17 31V32",
			stroke: "white",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 24,
			cy: 20,
			r: 4,
			stroke: "white",
			strokeWidth: 1.5
		})
	]
});
export default SvgIndividualRegister;
